import { render } from "./kundenportale.vue?vue&type=template&id=46954572"
import script from "./kundenportale.vue?vue&type=script&lang=js"
export * from "./kundenportale.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__